<!-- Ported from the Polaris kit: src/components/ui/breadcrumb/BreadcrumbItem.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <li
    data-slot="breadcrumb-item"
    :class="cn('inline-flex items-center gap-1.5', props.class)"
  >
    <slot />
  </li>
</template>
